import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import backIcon from "../../Assets/Images/Expand_left.png";
import checkIcon from "../../Assets/Images/CheckIcon.png";
import galleryIcon from "../../Assets/Images/GalleryIcon.png";

const CameraComponent = ({ onCapture, onClose }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [previewImage, setPreviewImage] = useState(null);

  // Function to start the camera stream
  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoRef.current.srcObject = stream;
    } catch (error) {
      console.error("Error accessing the camera: ", error);
    }
  };

  // Function to stop the camera stream
  const stopCamera = () => {
    const stream = videoRef.current?.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
    setPreviewImage(null);
  };

  // Function to capture an image from the video stream
  const handleCaptureClick = () => {
    const context = canvasRef.current.getContext("2d");
    context.drawImage(
      videoRef.current,
      0,
      0,
      canvasRef.current.width,
      canvasRef.current.height
    );
    const imageDataURL = canvasRef.current.toDataURL("image/png");
    setPreviewImage(imageDataURL);
  };

  // Function to confirm captured image
  const handleConfirmClick = () => {
    if (previewImage) {
      onCapture(previewImage);
      stopCamera();
    }
  };

  useEffect(() => {
    startCamera();
    return () => {
      stopCamera();
    };
  }, []);

  return (
    <div className="camera-screen-container">
      <div className="camera-header">
        <button className="back-button" onClick={onClose}>
          <img src={backIcon} alt="Back" className="icon-image" />
        </button>
        <span>Camera</span>
      </div>

      <div className="camera-image-area">
        {previewImage ? (
          <img
            src={previewImage}
            alt="Captured Preview"
            style={{ width: "100%" }}
          />
        ) : (
          <video ref={videoRef} autoPlay style={{ width: "100%" }}></video>
        )}
        <canvas
          ref={canvasRef}
          style={{ display: "none" }}
          width="640"
          height="480"
        ></canvas>
      </div>

      <div className="camera-footer">
        <img src={galleryIcon} alt="Gallery" className="footer-icon" />
        <div className="camera-capture-button" onClick={handleCaptureClick}>
          <span></span>
        </div>
        <img
          src={checkIcon}
          onClick={handleConfirmClick}
          alt="Check"
          className="footer-icon"
          style={{ opacity: previewImage ? 1 : 0.5 }}
        />
      </div>
    </div>
  );
};

CameraComponent.propTypes = {
  onCapture: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CameraComponent;
